/**
 * 素材库路由
 */
'use strict';
angular.module('resourceCenterMaterialModule').config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.resourcectrl.material.personal', {
                url: '/personalmaterial?resourcetype&parentfcode',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/materialResource/material_main_tpl.html',
                        controller: 'personalMaterialCtrl',
                    },
                },
            })
            .state('front.resourcectrl.material.share', {
                url: '/sharematerial?resourcetype&parentfcode',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/materialResource/material_main_tpl.html',
                        controller: 'shareMaterialCtrl',
                    },
                },
            })
            .state('front.resourcectrl.material.compile', {
                url: '/compilematerial?resourcetype&parentfcode',
                views: {
                    'main@front.resourcectrl': {
                        templateUrl: './resourceCenter/materialResource/material_main_tpl.html',
                        controller: 'compileMaterialCtrl',
                    },
                },
            });
    },
]);
